import { message, Segmented, Select } from "antd"
import TaskItem from "./TaskItem"
import { TODO_STATUS_PENDING, TODO_STATUS_COMPLETED, USER_TYPE_ORGANIZATION, USER_TYPE_PARTNER } from "../../../constants/constants"
import { useEffect, useMemo, useState } from "react";
import NoDataIcon from "../../../components/icons/NoDataIcon";
import UploadProductAssetModal from "../../Organization/components/modals/UploadProductAssetModal";
import Spinner from "../../Organization/components/Spinner";
import { GetOrgTodos, GetPartnerTodosByUserID } from "../../../API/endpoints/Todos";
import dayjs from "dayjs";
import { uploadBrandDoc, uploadBrandMandatoryFile } from "../../../API/endpoints/Brands";
import { uploadPartnerFile, UploadPartnerMandatoryFile } from "../../../API/endpoints/Partner";
import { io, Socket } from "socket.io-client";

let socket: Socket;
interface Props {
    brands: any[]
    userProfile: any;
}
const TasksSection = (props: Props) => {
    const { brands, userProfile } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(true);
    const [selectedBrand, setSelectedBrand] = useState("");

    const [allDocs, setAllDocs] = useState<any>([]);
    const [list, setList] = useState<any>([]);
    const [reload, setReload] = useState(false);
    const [selectedType, setSelectedType] = useState(TODO_STATUS_PENDING);




    useEffect(() => {
        if (userProfile?.org_id) {
            setLoading(true);
            GetOrgTodos(userProfile?.org_id)?.then((res: any) => {
                setAllDocs(res?.data?.rows || []);
                setLoading(false);
            }).catch((err) => {
                setLoading(false);
                console.log('err', err);
            })

        } else if (userProfile?.user_type === USER_TYPE_PARTNER && userProfile?.partnerv2_id) {
            GetPartnerTodosByUserID(userProfile?.partnerv2_id, userProfile?.id).then((res) => {
                setAllDocs(res?.data?.rows || []);
                setLoading(false);
            }).catch((err) => {
                console.log("err", err);
                setLoading(false);
            })
        } else {
            setLoading(false)
        }

    }, [userProfile])


    useEffect(() => {

        let filteredList = allDocs;

        if (selectedBrand) {
            filteredList = filteredList?.filter((item: any) => item?.brand_id === selectedBrand);
        }

        if (selectedType) {
            filteredList = filteredList?.filter((item: any) => item?.status === selectedType);
        }

        setList(filteredList || []);
    }, [allDocs, selectedBrand, selectedType])


    useEffect(() => {
        socket = io(process.env.REACT_APP_API_URL_SOCKET || "http://localhost:3001", { path: "/aeg" });

        socket.on("connect", () => {
            console.log("Connected:", socket.id);
        });

        if (userProfile?.id) {
            socket.emit("register-user", userProfile?.id);
        }

        if (userProfile?.partnerv2_id) {
            socket.emit("connect-partner-user", userProfile?.id, userProfile?.partnerv2_id);
        }

        if (userProfile?.org_id) {
            socket.emit("connect-org-user", userProfile?.id, userProfile?.org_id);
        }

        return () => {
            socket.disconnect();
        };
    }, [userProfile]);



    const onChangeMenu = (tab: string) => {
        setSelectedType(tab)
    }

    const handleUploadFile = (data: any, file: any): Promise<any> => {
        if (!file) return Promise.reject("No file provided");
        if (userProfile?.user_type === USER_TYPE_ORGANIZATION) {
            const req = new FormData();
            req.append("brand_id", data?.brand_id);
            req.append("file", file);
            req.append("file_name", data?.sub_title);
            req.append("file_type", "Brand Assets");
            req.append("service", "1");
            req.append("description", data?.message);
            req.append("todo_id", data?.id);

            if (data?.upload_field !== "non mandatory") {
                req.append("field", data?.upload_field);
            }

            const uploadFn = data?.upload_field === "non mandatory"
                ? uploadBrandDoc
                : uploadBrandMandatoryFile;

            return uploadFn(req)
                .then((res: any) => {
                    onSuccessUploadAsset(data);
                    socket.emit("get-org-task-count", { userId: userProfile?.id, orgId: userProfile?.org_id })
                    return res; // resolve the result so the caller gets it
                })
                .catch((err) => {
                    console.error('err', err);
                    messageApi.error("Failed to upload file. pls try again!")
                    throw err; // rethrow so caller can handle it
                });
        } else {
            const req = new FormData();
            req.append("partner_id", userProfile?.partnerv2_id);
            req.append("file", file);
            req.append("file_name", data?.sub_title);
            req.append("file_type", "Partner Assets");
            req.append("service", "1");
            req.append("description", data?.message);
            req.append("todo_id", data?.id);

            if (data?.upload_field !== "non mandatory") {
                req.append("field", data?.upload_field);
            }

            const uploadFn = data?.upload_field === "non mandatory"
                ? uploadPartnerFile
                : UploadPartnerMandatoryFile;

            return uploadFn(req)
                .then((res: any) => {
                    onSuccessUploadAsset(data);
                    socket.emit("get-partner-task-count", { userId: userProfile?.id, partnerId: userProfile?.partnerv2_id });
                    return res; // resolve the result so the caller gets it
                })
                .catch((err) => {
                    console.error('err', err);
                    messageApi.error("Failed to upload file. pls try again!")
                    throw err; // rethrow so caller can handle it
                });
        }

    };


    const onSuccessUploadAsset = (data: any) => {
        const allList = [...allDocs];
        const index = allList?.findIndex((item: any) => item?.id === data?.id)
        if (index > -1) {
            allList[index] = {
                ...allList[index],
                status: TODO_STATUS_COMPLETED,
                completed_at: dayjs().toISOString()
            }
        }
        setAllDocs([...allList])
        messageApi.success("Document uploaded successfully");
    }


    const menuOptions = useMemo(() => {
        return [
            {
                label: "Pending",
                value: TODO_STATUS_PENDING
            },
            {
                label: "Done",
                value: TODO_STATUS_COMPLETED
            }
        ]
    }, [])

    const tasksList = useMemo(() => (
        list?.map((item: any) => (
            <TaskItem key={item?.id} data={item} onUpload={(data, file) => handleUploadFile(data, file)} />
        ))
    ), [list])

    return (
        <div className="flex-1 bg-white rounded-[8px] p-[16px]">
            {contextHolder}
            <div className="flex items-center gap-x-[12px] justify-between">
                <div className="flex items-center gap-x-[4px]">
                    <p className="text-[14px] font-medium m-0">Tasks {userProfile?.user_type === USER_TYPE_ORGANIZATION ? "-" : ""}</p>
                    {userProfile?.user_type === USER_TYPE_ORGANIZATION ? (
                        <Select
                            className="min-w-[120px]"
                            size="small"
                            variant="borderless"
                            options={[{ brand_name: "All", id: "" }, ...brands]}
                            fieldNames={{ label: "brand_name", value: "id" }}
                            defaultValue={""}
                            onChange={(value) => setSelectedBrand(value)}
                        />
                    ) : (
                        <></>
                    )}

                </div>
                <Segmented
                    options={menuOptions}
                    onChange={(value) => {
                        onChangeMenu(value)
                    }}
                    defaultValue={TODO_STATUS_PENDING}
                />
            </div>
            <div className="flex flex-col gap-y-[16px] mt-[12px] h-[calc(100%-40px)] overflow-auto overflow-scroll-bar pr-1">
                {
                    loading ? (
                        <Spinner />
                    ) : (
                        list?.length > 0 ? (
                            tasksList
                        ) : (
                            <div className="w-full h-full flex justify-center items-center">
                                <NoDataIcon />
                            </div>

                        )
                    )

                }
            </div>
        </div>
    )
}

export default TasksSection
